export const STATE_KEY = 'dataRefresh';
export const POLLING_PERIOD = 60 * 1000;
